import { scrollTo } from "./Nav";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-treeline py-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <p className="font-mono text-xs text-sage">
          © {new Date().getFullYear()} Sarron A. Tadesse · Designed &amp; built with intent.
        </p>
        <button
          data-testid="footer-back-to-top"
          onClick={() => scrollTo("#top")}
          className="font-mono text-xs uppercase tracking-[0.25em] text-sage hover:text-lime transition-colors duration-300"
        >
          Back to top ↑
        </button>
      </div>
    </footer>
  );
}
